@if(processingLoginToken){
    <div>
        <div class="va-login-head">
            <div class="va_desc">
                <div class="h4">
                    <mat-icon>sync</mat-icon>
                    Signing you in...
                </div>
                <p class="loading-subtitle" i18n>Please wait while we verify your credentials</p>
            </div>
        </div>
        <mat-progress-bar mode="indeterminate" aria-label="Login in progress"></mat-progress-bar>
    </div>
}@else{
    <div [@flyInOut]="state" [hidden]="isHidden" class="login_bg mb-5" *ngIf="!showSSOAccess">
        <div class="va-login-head">
            <div class="va_desc">
                <div class="h4" i18n>Sign in to your account</div>
            </div>
        </div>
        <ng-container>
            <form (keyup.enter)="onLoginClicked()" [formGroup]="loginForm" novalidate data-cy="login-form">
                <div class="input_wrp">
                    <label class="c2" i18n>Username</label>
                    <div class="login_form_input login_padding">
                        <input [placeholder]="translate.stream('LOGIN.PLACEHOLDERS.USER_OR_EMAIL') | async" class="login_img user_img form-control" formControlName="username" name="passwordForm" aria-label="Enter username or email" data-cy="login-form-input-email" autocomplete="email">
                    </div>
                    <div *ngIf="isSubmitted" class="login_error">
                        <ng-container *ngIf="(errorStr$ | async) as errors">
                            {{ errors.username }}
                        </ng-container>
                    </div>
                </div>

                <div class="input_wrp">
                    <label class="c2" i18n>Password</label>
                    <div class="login_form_input login_padding">
                        <input [placeholder]="translate.stream('LOGIN.PLACEHOLDERS.PASS') | async" [type]="isPwVisible ? 'text' : 'password'" class="login_img pass_img form-control" formControlName="password" name="passwordForm" aria-label="Enter password" data-cy="login-form-input-password" autocomplete="current-password">
                        <i (click)="togglePasswordVisible()" [ngClass]="isPwVisible ? 'active' : 'unclicked'" class="icon-pwd login_pass_eye_img" data-cy="login-form-i-show-password"></i>
                    </div>
                    <div *ngIf="isSubmitted" class="login_error">
                        <ng-container *ngIf="(errorStr$ | async) as errors">
                            {{ errors.password ? errors.password : errors.incorrect }}
                        </ng-container>
                    </div>
                </div>
            </form>

            <div class="login_form_ctrl">
                <div class="reset_pass_wrp">
                    <div class="main_gray_ada fs-14 reset_pass_inner">
                        <mat-checkbox [(ngModel)]="isRememberMeEnabled"><span class="c5" i18n>Remember me</span></mat-checkbox>
                        <span class="c-p resetpass_link c3" (click)="onForgotPassword()" data-cy="login-div-forget-password">{{
                                translate.stream('LOGIN.FORGOT_PASS') | async
                            }}</span>
                    </div>
                </div>

                <div class="d-flex align-items-end">
                    <!-- Show email login container -->
                    <button mat-button class="btn btn-act btn-xxl va-btn-bg w-100" (click)="onLoginClicked()" data-cy="login-button-login">
                        <ng-container *ngIf="!isLoggingIn">Sign in</ng-container>
                        <ng-container *ngIf="isLoggingIn">
                            <app-button-loading-spinner></app-button-loading-spinner>
                        </ng-container>
                    </button>

                    <div hidden>
                        <button mat-button class="btn btn-act btn-xxl yellow-btn w-100" (click)="onJakLogin()" data-cy="login-button-sms-login">{{ 'PATIENT_OVERVIEW.SMS_LOGIN' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- optional login -->
            <div class="or-continue-with c2"><span i18n>OR</span></div>
            <div class="mt-4">
                <button class="sso primary-black-btn btn btn-act btn-xxl va-btn-bg w-100" (click)="onSSOLogin()" mat-raised-button i18n>Sign in with VA
                    SSO
                </button>
            </div>
            <div class="mt-4" *ngIf="!showEmailLogin">
                <button class="sso login-optional-button primary-white-btn" (click)="onSSOiLogin()" mat-raised-button i18n>Sign
                    in with VA SSOi
                </button>
            </div>
        </ng-container>



        <ng-container *ngIf="showRegister">
            <div class="login_new_label_container">
                <div class="login_new_label">
                    <hr class="login_hr_left">
                    {{ labels?.registerTitle }}
                    <hr class="login_hr_right">
                </div>
            </div>
            <div class="login_register" (click)="onCreateAccount()" routerLink="/profile/1" data-cy="login-div-label-register">
                {{ labels?.register }}
            </div>
        </ng-container>

    </div>

    <ng-container *ngIf="showSSOAccess && ssoLogin">
        <div class="login_bg white-bg-box">
            <div class="access-card text-align-center">
                <div class="card-img mb-4">
                    <img [src]="accessImg" alt="VA Access Required Image" class="w-100">
                </div>
                <div class="card-body mb-1 text-align-center">
                    <div class="h4" i18n> Thank you for your interest in CuraVet!</div>
                    <div class>
                        <p class="fs-15" i18n> You have not been activated to use CuraVet. If you are interested or think you
                            should have access to this application, please tap below to request access. </p>
                        <p class="fs-15" i18n> Your request will be processed within 72 hours. </p>
                    </div>

                    <mat-form-field class="mt-4" [ngClass]="selectedReuestOrganization ? 'hide-label' : ''">
                        <mat-select [value]="selectedReuestOrganization?.id" [(ngModel)]="selectedReuestOrganization" placeholder="Select an Organization" required>
                            <mat-option *ngFor="let org of organizations" [value]="org">
                                {{ org?.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button mat-raised-button class="w-100 btn btn-xs mt-4 va-btn-bg" [disabled]="!selectedReuestOrganization" (click)="sendAccessRequest()" i18n>Request Access
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
}
